import { mod10 } from "./mod10";

export function adicionaDigitos(YY: string) {
   
    const AA1 = YY.substring(0, 11);

    const AA1_dig = mod10(AA1);     //pp STRING QUE JA TEM UM DIGITO VERIFICADOR

   
    const AA2 = YY.substring(11, 22);

 
    const AA2_dig = mod10(AA2);
   // window.alert(AA2+AA2_dig)
    console.log("AQUI ESTAO OS DIGITOS: " , AA2+AA2_dig)
    const AA3 = YY.substring(22, 33);
    const AA3_dig = mod10(AA3);

    const AA4 = YY.substring(33, 44);
    const AA4_dig = mod10(AA4);

   

    return (AA1 + String(AA1_dig) +" "+ AA2 + String(AA2_dig)+" " + AA3 + String(AA3_dig)+" " + AA4 + String(AA4_dig));

}